<template>
    <dash
        icon="fa fa-dollar"
        titulo="PAGAMENTOS GESCON"
        @click.native="$router.push({ name: 'Gescon_Financeiro_Pagamentos' })"
        :qtd="qtd"
        :mostrarQtd="true"
        :qtd2="qtd2"
        :mostrarQtd2="true"
        :loading="loading"
    ></dash>
</template>

<script>
import Dash from '@/shared/components/DashComponent'

export default {
    props: {
        qtd: {
            type: Number
        },

        qtd2: {
            type: Number
        },

        loading: {
            type: Boolean
        }
    },

    components: {
        Dash
    },

    data() {
        return {}
    }
}
</script>
